module.exports = __webpack_public_path__ + "img/hold-reservation.d63c4eb8.jpg";